module.exports = __webpack_public_path__ + "static/media/u.9b775d40.png";